import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  border-radius: 100%;\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { BUTTON_CIRCLE_SIZE, BUTTON_CIRCLE_SIZE_SMALL, BUTTON_CIRCLE_SIZE_TINY } from './constants';
import IconButton from './IconButton';
import { BACKGROUND_GRAY, LINE_GRAY, SENSATION_WHITE } from '../colors';
import { getPx } from '../helpers/common';
import { isDefined } from '../helpers/defined';
import { styleForBreakpoints } from '../helpers/media-style';
import { withOmitProps } from '../helpers/elements';
import { buttonBackgroundColorKeys, buttonBackgroundColorMixin } from './style/background-color';
import { buttonBoxShadowKeys, buttonBoxShadowMixin } from './style/box-shadow';
import { size } from '../style/size';
var SIZE = {
  tiny: BUTTON_CIRCLE_SIZE_TINY,
  small: BUTTON_CIRCLE_SIZE_SMALL,
  medium: BUTTON_CIRCLE_SIZE
};
var CircleButton = styled(IconButton).withConfig(withOmitProps([].concat(buttonBackgroundColorKeys, buttonBoxShadowKeys)))(_templateObject(), buttonBoxShadowMixin, buttonBackgroundColorMixin, function (_ref) {
  var $size = _ref.$size,
      _ref$sizeVariant = _ref.sizeVariant,
      sizeVariant = _ref$sizeVariant === void 0 ? 'medium' : _ref$sizeVariant;
  return isDefined($size) ? size($size) : typeof sizeVariant === 'string' ? size(SIZE[sizeVariant] || SIZE.medium) : styleForBreakpoints(sizeVariant, function (sizeVariant, breakpoint) {
    return "\n            width: " + getPx((SIZE[sizeVariant] || SIZE.medium)[breakpoint]) + ";\n            height: " + getPx((SIZE[sizeVariant] || SIZE.medium)[breakpoint]) + ";\n          ";
  });
});
var CircleIconButton = /*#__PURE__*/React.forwardRef(function (_ref2, forwardedRef) {
  var as = _ref2.as,
      forwardedAs = _ref2.forwardedAs,
      size = _ref2.size,
      _ref2$sizeVariant = _ref2.sizeVariant,
      sizeVariant = _ref2$sizeVariant === void 0 ? 'medium' : _ref2$sizeVariant,
      props = _objectWithoutPropertiesLoose(_ref2, ["as", "forwardedAs", "size", "sizeVariant"]);

  return /*#__PURE__*/React.createElement(CircleButton, _extends({
    forwardedAs: forwardedAs != null ? forwardedAs : as,
    ref: forwardedRef,
    size: null,
    $size: size,
    sizeVariant: sizeVariant,
    noShadow: false,
    noShadowActive: false,
    noShadowHover: false,
    noShadowFocus: false,
    noShadowDisabled: false,
    backgroundColor: SENSATION_WHITE,
    activeBackgroundColor: BACKGROUND_GRAY,
    hoverBackgroundColor: SENSATION_WHITE,
    focusBackgroundColor: SENSATION_WHITE,
    disabledBackgroundColor: LINE_GRAY
  }, props));
});
export default CircleIconButton;